// extracted by mini-css-extract-plugin
export default {"root":"Stretch_root__sjPJY"};